import { render, staticRenderFns } from "./accountAppsSettings.vue?vue&type=template&id=65a978c7&"
import script from "./accountAppsSettings.vue?vue&type=script&lang=js&"
export * from "./accountAppsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports